import React, {useEffect, useState} from 'react';
import {useHistory, useRouteMatch,} from 'react-router-dom';
import InspectionFormPageView from './InspectionFormPage-view';
import SplashScreen from 'common/components/SplashScreen';
import {
  DecisionTreeOptionsContextProvider,
  DecisionTreeShumaTypesOptionsContextProvider
} from '../../../../common/components/DecisionTreeOptions';
import {pathnames as P} from 'common/constants/pathnames';
import {errors as E} from '../../../../common/constants/errors';

const InspectionFormPage = ({
                              stepStatus,
                              getShumaStepStatus,
                              stepData,
                              getStepData,
                              getShumaProperties,
                              clearInspectionData,
                              stepDataLoading,
                              stepDataError,
                              shumaTypeID,
                              firmShumaID,
                              showGlobalErrorMessage
                            }) => {
  const history = useHistory();
  const {params: {shumaId, formId}} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    setShowSplash(true);
    getShumaStepStatus({shumaId});
    getShumaProperties({shumaId});
  }, [shumaId]);

  useEffect(() => {
    setShowSplash(false);
  }, [formId]);

  useEffect(() => {
    if (parseInt(formId, 10) !== 9) { // there is no form data for step 9
      getStepData({shumaId, stepId: formId});
    }
  }, [shumaId, formId]);

  useEffect(() => () => clearInspectionData(), []);

  useEffect(() => {
    if (stepDataError) {
      showGlobalErrorMessage(E.NOT_ALLOWED, () => history.replace(P.MAIN_MENU));
    }
  }, [stepDataError]);

  const isStepAllowed = ({allowedShumaTypeIDs}) => {
    if (typeof allowedShumaTypeIDs === 'number') {
      return allowedShumaTypeIDs === shumaTypeID;
    }
    if (allowedShumaTypeIDs instanceof Array) {
      return allowedShumaTypeIDs.includes(shumaTypeID);
    }
    return true;
  };

  return ((stepStatus === null || stepData === null) && showSplash)
    ? <SplashScreen/>
    : (
      <DecisionTreeOptionsContextProvider>
        <DecisionTreeShumaTypesOptionsContextProvider>
          <InspectionFormPageView
            stepStatus={stepStatus || {}}
            shumaId={shumaId}
            firmShumaID={firmShumaID}
            shumaTypeID={shumaTypeID}
            stepDataLoading={stepDataLoading}
            formId={formId}
            isStepAllowed={isStepAllowed}
          />
        </DecisionTreeShumaTypesOptionsContextProvider>
      </DecisionTreeOptionsContextProvider>
    );
};

export default InspectionFormPage;